import { render, staticRenderFns } from "./sleadList.vue?vue&type=template&id=b21cd6a0&scoped=true"
import script from "./sleadList.vue?vue&type=script&lang=js"
export * from "./sleadList.vue?vue&type=script&lang=js"
import style0 from "./sleadList.vue?vue&type=style&index=0&id=b21cd6a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21cd6a0",
  null
  
)

export default component.exports